import React from "react";

import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

const SidebarItem = ({ to, icon, text }) => {
  return (
    <Link to={{
      pathname: to,
      state: {remount: true}
    }}>
      <ListItem button>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{text}</ListItemText>
      </ListItem>
    </Link>
  );
};

export default SidebarItem;
